// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__39ipr","index":"styles_index__1LjgR"};